import gql from 'graphql-tag';

const CSV_COLUMN_INFO_FRAGMENT = gql`
  fragment CSVColumnInfo on CSVColumnInfo {
    index
    name
  }
`;

export const CUSTOM_DATASET_FRAGMENT = gql`
  fragment CustomDataset on CustomDataset {
    id
    title
    assetTypes
    metricToPredict
    status
    dataPointsSize
    processingError
    createdAt
  }
`;

export const CUSTOM_DATASET_FULL_FRAGMENT = gql`
  fragment CustomDatasetFull on CustomDataset {
    ...CustomDataset
    callToActionUrls
    postTextColumns {
      ...CSVColumnInfo
    }
    impressionsColumns {
      ...CSVColumnInfo
    }
  }
  ${CSV_COLUMN_INFO_FRAGMENT}
  ${CUSTOM_DATASET_FRAGMENT}
`;

export const CUSTOM_DATASET_DATA_POINT_FRAGMENT = gql`
  fragment CustomDatasetDataPoint on CustomDatasetDataPoint {
    id
    postText
    impressions
    acApproved
    userApproved
  }
`;
